import { ServiceRequestType } from "../../../../model/service-request/service-request";
import { FieldType } from "../../../../model/service-request/attribute";
import { DynamicFieldItem } from "../../../../model/dynamic-forms";
import {
	SubmitServiceRequestPayload,
	SubmitServiceRequestSectionPayload,
	SubmitServiceRequestAttributePayload,
} from "../../../../service/customersupport-service";

function mapField(field: DynamicFieldItem): SubmitServiceRequestAttributePayload {
	const attr: SubmitServiceRequestAttributePayload = { attributeDefinitionId: field.fieldId };

	switch (field.fieldType) {
		case FieldType.Dropdown:
		case FieldType.SingleSelect:
		case FieldType.ConditionalDropdown:
		case FieldType.ChildDropdown:
			if (field.selectedChildIds && field.selectedChildIds.length > 0) {
				attr.selectedOptionIds = field.selectedChildIds;
			} else if (Array.isArray(field.fieldValue)) {
				attr.selectedOptionIds = field.fieldValue.map(String);
			} else if (field.selectedChildId || field.fieldValue) {
				attr.selectedOptionIds = [field.selectedChildId || String(field.fieldValue)];
			}
			break;

		case FieldType.MultiSelect:
			if (Array.isArray(field.fieldValue)) {
				attr.selectedOptionIds = field.fieldValue.map(String);
			}
			break;

		case FieldType.DateTime:
			if (field.fieldValue instanceof Date) {
				attr.dateValue = field.fieldValue.toISOString();
			} else if (field.fieldValue) {
				attr.dateValue = String(field.fieldValue);
			}
			break;

		case FieldType.Bool:
			if (field.fieldValue != null) {
				attr.boolValue = Boolean(field.fieldValue);
			}
			break;

		case FieldType.Number:
			if (field.fieldValue != null) {
				attr.doubleValue = typeof field.fieldValue === "number" ? field.fieldValue : parseFloat(field.fieldValue) || 0;
			}
			break;

		case FieldType.File:
		case FieldType.Image:
			if (field.fieldValue instanceof File) {
				attr.file = field.fieldValue;
			}
			break;

		default:
			attr.stringValue = field.fieldValue?.toString() ?? "";
			break;
	}

	return attr;
}

export function buildSubmitPayload(
	serviceRequest: ServiceRequestType,
	sectionValues: DynamicFieldItem[][]
): SubmitServiceRequestPayload {
	const sections: SubmitServiceRequestSectionPayload[] = serviceRequest.sectionDefinitions.map((section, index) => {
		const enteredByFieldId = new Map((sectionValues[index] ?? []).map(value => [value.fieldId, value]));
		const attributes: SubmitServiceRequestAttributePayload[] = (section.attributeDefinitions ?? []).map(definition => {
			const entered = enteredByFieldId.get(definition.id);
			return entered ? mapField(entered) : { attributeDefinitionId: definition.id };
		});
		return { sectionDefinitionId: section.id ?? "", attributes };
	});

	return {
		serviceRequestId: serviceRequest.id,
		requestTypeId: serviceRequest.requestTypeId ?? "",
		sections,
	};
}
